export enum ActionTypes {
    CONFIG_LOADED = 'RF_CONFIG_LOADED',
    UI_INTEGRATE_UPDATED = 'RF_UI_INTEGRATE_UPDATED',
    UI_BYOD_UPDATED = 'RF_UI_BYOD_UPDATED',
    UI_TEMPLATES_UPDATED = 'RF_UI_TEMPLATES_UPDATED',
    UI_WEBHOOK_UPDATED = 'RF_UI_WEBHOOK_UPDATED',
    KEY_UPDATED = 'RF_KEY_UPDATED',

    TOGGLE_TOKEN_VISIBILITY = 'RF_TOGGLE_TOKEN_VISIBILITY',
}



// WEBPACK FOOTER //
// ./src/sub-projects/roostify/types/action-types.ts